import { useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import BoltIcon from '@mui/icons-material/Bolt';
import { CircularProgress, List, ListItem, ListItemIcon, ListItemText, TextField } from '@mui/material';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PsychologyIcon from '@mui/icons-material/Psychology';
import { Box } from '@mui/system';
import { registerUserForAssistCourse } from '../../facades/UserFacade';
import { UserContext } from '../../contexts/userContext';
import { useContext } from 'react';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function BuyNowPopup({ openDialog, handleClose, subjectName, subjectId }) {

    const [paymentDetailsVisible, setPaymentDetailsVisible] = useState(null);
    const userContext = useContext(UserContext);
    const [registering, setRegistering] = useState(false);

    const hClose = () => {
        setPaymentDetailsVisible(null);
        handleClose();
    }

    const setP = (value) => {
        console.log("Setting", value)
        setPaymentDetailsVisible(value);
    }

    const register = () => {
        setRegistering(true)
        registerUserForAssistCourse(userContext.user, subjectId)
            .then(res => res.json())
            .then(res => {
                if (res['status'] === 'success') {
                    //reload the page 
                    window.location.reload();
                }
            })
        setRegistering(false);
    }

    return (
        <>
            <BootstrapDialog
                onClose={hClose}
                aria-labelledby="customized-dialog-title"
                open={openDialog}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Ready to feel confident, not stressed?
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={hClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Typography variant='h5'>
                        Get the ultimate exam edge now!
                    </Typography>
                    <Typography variant='subtitle1'>
                        Get early access to Module 1 of {subjectName} for FREE!
                    </Typography>
                    <Typography variant='subtitle1'>
                        The full {subjectName} Learning Course includes :
                    </Typography>
                    <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                        <nav aria-label="main mailbox folders">
                            <List>
                                <ListItem>
                                    <ListItemIcon>
                                        <BoltIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="250 Quiz Questions"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <OndemandVideoIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="50+ tutorial videos"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <AccessTimeIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="2 Full Practice Exams"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <PsychologyIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Ask the Expert Forums"
                                    />
                                </ListItem>
                            </List>
                        </nav>
                    </Box>
                    



                </DialogContent>
                <DialogActions>
                    <Button size="large" sx={{ bgcolor: '#F5EE00', color: 'black' }} onClick={() => register()} disabled={registering}>
                        {"I'm in!"}
                        {registering && (
                            <CircularProgress
                                size={20}
                                sx={{
                                    color: 'black',
                                    marginLeft: '10px', // Add spacing between text and spinner
                                }} />
                        )}
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </>
    );
}
